export default __webpack_public_path__ + "static/media/dark_close.e5f295b8.svg";